export interface Subject {
  id: number;
  subject_last_name: string;
  subject_first_name: string;
  subject_middle_name: string;
  subject_prefix: string;
  subject_sex?: string;
  subject_death_indicator?: string | null;
  subject_id: string;
  subject_alternative_id: string | null;
  subject_visit_id: string | null;
  subject_dob: string; // ISO string
  admit_date: string | null; // ISO string or null
  discharge_date: string | null; // ISO string or null
  patient_status: string;
  patient_list_user: string;
  facility_identifier: string;
  order_id: number | null;
  facility_id: number;
  task_array: unknown[];
}

/** Patient search (`allSubjects=true`) answers with a paginated envelope rather than a bare array. */
export interface SubjectSearchResult {
  count: number;
  rows: Subject[];
}

/**
 * A patient is considered custom (manually created) when both [facility_id]
 * and [subject_alternative_id] are absent.
 *
 * The [subject_alternative_id] check is a workaround for legacy data that
 * predates the [facility_id] field. Once all subject records include
 * [facility_id], the [subject_alternative_id] fallback should be removed.
 *
 * Mirrors Flutter's `Patient.isCustom`.
 */
export function isCustomSubject(subject?: Pick<Subject, 'facility_id' | 'subject_alternative_id'> | null): boolean {
  if (!subject) return true;
  return !subject.facility_id && !subject.subject_alternative_id;
}
